import React, { Component } from 'react'
import styled, { keyframes, css } from 'styled-components'
import { media } from 'styled-bootstrap-grid'
import { Link, withRouter } from 'react-router-dom'

import getRelativeUrl from 'utils/getRelativeUrl'
import index from '../modules/Header/index'

class Nav extends Component {
  constructor(props) {
    super(props);
    this.state = {
      solid: this.props.solid
    }
  }



  determineActivity = (item, location) => {
    if(getRelativeUrl(item.url) === location.pathname){
      console.log(item.childItems.url)
    } else {
    }    
  }

isItActive = (item, location) => {
  //console.log(item.childItems !== 0 && item.childItems.map((link, index) => (getRelativeUrl(link.url) === location.pathname)))
  //if(item.childItems !== 0 && item.childItems.map((link, index) => (getRelativeUrl(link.url) === location.pathname))){
    //return true
  //} else {
  //  return false
 // }
 console.log((item.childItems.map((link, index) => (getRelativeUrl(link.url) === location.pathname))).includes(true))
}  

  render() {
    const {
      items,
      onItemMouseEnter,
      onItemMouseLeave,
      location,
      inverted,
      locale,
      onClickLink,
      solid
    } = this.props




    return (
      <Wrapper inverted={inverted}>
        {items.map((item, index) => (
          <NavItem
            key={`${locale}-${item.id}`}
            active = {item.childItems !== 0 && (item.childItems.map((link, index) => (getRelativeUrl(link.url) === location.pathname))).includes(true) || getRelativeUrl(item.url) === location.pathname}
            onMouseEnter={() => onItemMouseEnter(item)}
            onMouseLeave={() => onItemMouseLeave()}
            onClick={()=>onClickLink()}
            highlighted={item.label === "Contact" || item.label === "Kontakt" || item.label === "Contacto" || item.label === "联系" || item.label === "お問い合わせ先" ? 1 : 0}
            solid={solid}
          >
            <Link
              to={getRelativeUrl(item.url)}
            >{item.label}</Link>
          </NavItem>))
        }
      </Wrapper>
    );
  }
}

export default withRouter(Nav)

// Styles
const entry = keyframes`
  0% {
    opacity: 0;
    transform: translateY(20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0px);
  }
`

const NavItem = styled.li`
  display: inline-flex;
  position: relative;
  height: 100%;
  padding: 0 10px;
  align-items: center;
  transition: all 0.4s ease;

  ${props => props.active &&
    css`
    a{
      border-bottom: 1px solid ${props => props.solid ? "black" : "white"};
    }
    ` 
  }

  animation: ${entry} 1000ms both;
  ${props => props.highlighted &&
    css`
    background-color: #00994c;
    color: white !important;
    border-radius: 25px;
    height: 40%;

    a {
      color: white !important;
    }

    ${props => props.active && 
      css`
        a {
          color: white !important;
          border-bottom: 1px solid white;
        }
      `}

  `}




    ${media.xl`
      padding: 0 17px;
    `}



  a {
    text-decoration: none;
    
    font-weight: 500;
    text-transform: uppercase;
    font-size: min(0.65vw, 13px);

    transition: all 400ms color 800ms;
  }

  &:after {
    display: block;
    content: "";
    position: absolute;
    transition: all 700ms;

    top: 0px;
    left: 15px;
    right: 15px;
    height: 4px;

    opacity: ${props => props.active ? 1 : 0};
    transform: scale(${props => props.active ? 1 : 0}, 1);
  }
`

const Wrapper = styled.ul`
  list-style: none;
  text-align: center;
  padding: 0;
  margin: 0;
  height: 100%;
  display: none;


  ${media.lg`
    display: block;
  `}

  a {
    color: ${props => props.inverted ? props.theme.colors.tones.darker : '#fff'};

    &:after {
      background-color: ${props => props.inverted ? props.theme.colors.primary : '#fff'};
    }
  }
`



// WEBPACK FOOTER //
// ./src/ui/components/Navigation/Nav.js